import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { useProps } from "contexts/PropsContext"

interface IProps {
  options: { name: string; value: string; disable?: boolean }[]
  id?: string
  title?: string
  value?: any
  onChange?: any
  invalid?: boolean
  altLabelOne?: string
  noAllValueText?: boolean
  bgColor?: string
  placeholder?: string
  disableEmptyOption?: boolean
  hideEmptyOption?: boolean
  disabled?: boolean
  name?: string
  rounded?: boolean
  loading?: boolean
}

export const DropdownMenu: FC<IProps> = (props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const {
    options,
    id,
    value,
    onChange,
    invalid,
    altLabelOne,
    noAllValueText,
    disableEmptyOption = false,
    hideEmptyOption = false,
    title,
    placeholder = t("common.all"),
    disabled = false,
    name,
    rounded,
    loading = false
  } = props

  const { darkMode } = useProps()

  return (
    <div className="w-full form-control relative">
      {Boolean(title) && (
        <label className="label">
          <span className={clsx("label-text", { "text-error": invalid })}>{title}</span>
        </label>
      )}
      <select
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        className={clsx(
          "select select-bordered outline-none !min-h-0 h-auto py-2 text-sm pl-3 pr-8",
          rounded && "rounded-full items-center text-left pl-[24px] appearance-none",
          {
            "select-error": invalid,
            "bg-[#0C0C1A] text-white border-[rgba(255,255,255,0.1)]": darkMode && rounded,
            "bg-[#F5F5F5] text-black border-gray-200": !darkMode && rounded
          }
        )}
        disabled={disabled || loading}
      >
        {loading && <option value="">Loading...</option>}
        <option key={0} value="" {...(disableEmptyOption && { disabled: true })} className={clsx({ hidden: hideEmptyOption })}>
          {!noAllValueText && placeholder}
        </option>
        {options.map(({ name, value, disable = false }) => (
          <option
            key={value}
            value={value}
            disabled={disable}
            className={clsx({
              "bg-[#0C0C1A] text-white border-[rgba(255,255,255,0.1)]": darkMode && rounded,
              "bg-white text-black border-gray-200": !darkMode && rounded
            })}
          >
            {name}
          </option>
        ))}
      </select>
      {loading && <span className="absolute right-10 top-3/4 -translate-y-1/2 loading loading-spinner loading-xs opacity-60" />}
      <label>
        <span className={clsx("label-text-alt", { "text-error": invalid })}>{altLabelOne}</span>
      </label>
    </div>
  )
}
